const sitePopup = {
  el: {
    videoId: "",
  },
  videoIframe(videoid) {
    return `<iframe src="https://www.youtube.com/embed/${videoid}/?autoplay=1" title="The Better India" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  },
  videoPopup() {
    jQuery(document).on("click", '[data-element="video"]', function (e) {
      e.preventDefault();
      var $href = jQuery(this).attr('href');
      sitePopup.el.videoId = jQuery(this).data("video");
      var $tracker = jQuery(this).data("tracker");
      dataLayersWP.videoStory($tracker);
      if (!!$href !== false && $href !== '#') {
        window.open($href, "_blank");
      } else {
        jQuery('[data-element="popup"]  [data-popup="body"]').html(
          sitePopup.videoIframe(sitePopup.el.videoId)
        );
        jQuery('[data-element="popup"]').addClass("vspl__popup--show");
      }
    });
  },
  searchPopup() {
    jQuery(document).on("click", '[data-element="search"]', function (e) {
      e.preventDefault();
      jQuery('[data-popup="search"]').addClass("vspl__popup--show");
    });

    jQuery(document).on(
      "click",
      '[data-popup="search"] [data-popup="close"]',
      function () {
        jQuery('[data-popup="search"]').removeClass("vspl__popup--show");
      }
    );
  },
  closePopup() {
    jQuery(document).on("click", '[data-popup="close"]', function () {
      jQuery('[data-element="popup"]  [data-popup="body"]').html(" ");
      jQuery('[data-element="popup"]').removeClass("vspl__popup--show");
    });
  },
  init() {
    this.videoPopup();
    this.searchPopup();
    this.closePopup();
  },
};
